export default __webpack_public_path__ + "static/media/Ruby_9781843620167.1df2b2eb.jpg";